"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheEssenceStory() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="61" id="the-essence-story" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      <div className="relative grid grid-cols-1 lg:grid-cols-[1fr_1fr] min-h-screen">
        {}
        <div ref={imageRef} className={`relative h-[60vh] lg:h-auto overflow-hidden transition-all duration-[1200ms] ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/perfume_bottle_floral_mist.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/perfume_bottle_floral_mist.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/perfume_bottle_floral_mist.png-wvc-sizes" alt="Elegant perfume bottle amidst delicate floral and mist elements" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/40" aria-hidden="true" />
        </div>

        {}
        <div ref={contentRef} className={`flex items-center px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24 transition-all duration-[1200ms] delay-200 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="w-full max-w-xl">
            {}
            <p className="font-mono text-xs uppercase tracking-[0.3em] mb-10" style={{
            color: "var(--primary)"
          }}>
              Our Vision &nbsp;/&nbsp; Essence & Co.
            </p>

            {}
            <blockquote className="font-default italic font-light text-foreground leading-[1.05] mb-12" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)"
          }}>
              <span className="block">"We don't</span>
              <span className="block">bottle scents.</span>
              <span className="block">We capture</span>
              <span className="block">the fleeting</span>
              <span className="block">memory of light."</span>
            </blockquote>

            {}
            <div className="flex items-center gap-4 mb-10" aria-hidden="true">
              <div className="h-px flex-1" style={{
              backgroundColor: "var(--primary)",
              opacity: 0.5
            }} />
              <span className="font-mono text-xs tracking-[0.2em]" style={{
              color: "var(--primary)"
            }}>
                01
              </span>
              <div className="h-px flex-1" style={{
              backgroundColor: "var(--primary)",
              opacity: 0.5
            }} />
            </div>

            {}
            <p className="text-foreground/85 leading-relaxed mb-10" style={{
            maxWidth: "460px",
            fontFamily: "var(--font-sans)"
          }}>
              For over a decade, Essence & Co. has curated the world's most elusive olfactory experiences.
              Each fragrance is a dialogue between rare botanicals and the skin, crafted to evoke 
              moments of profound beauty. Our process is not merely manufacturing; it is an artistic 
              endeavor to distill the essence of nature into a singular, timeless vessel.
            </p>

            {}
            <div className="mb-3">
              <span className="font-default italic text-3xl text-foreground" style={{
              opacity: 0.3
            }}>
                Essence & Co.
              </span>
            </div>

            {}
            <p className="font-mono text-[0.7rem] uppercase tracking-[0.25em] text-muted-foreground mb-10">
              Luxury Perfumery, Est. 2024
            </p>

            {}
            <Button asChild variant="link" className="px-0 h-auto text-foreground hover:text-primary group">
              <Link to="/OurHeritagePage" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em]">
                Discover our heritage
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}